import { Button, Dropdown, message } from "antd";
import { capitalize } from "lodash";
import { Link } from "react-router-dom";
import CopyIcon from "../../../../../assets/icons/CopyIcon";
import FlagIcon from "../../../../../assets/icons/FlagIcon";
import RefreshIcon from "../../../../../assets/icons/RefreshIcon";
import ThreeDotsIcon from "../../../../../assets/icons/ThreeDotsIcon";
import ViewIcon from "../../../../../assets/icons/ViewIcon";
import useModal from "../../../../../hooks/useModal";
import useTicket from "../../../../../hooks/useTicket";
import { formatValue } from "../../../../../utils/string";
import {
  MY_INVOLVED_CONFIG,
  PRIORITY_CONFIG,
  STATUS_CONFIG,
} from "../AllTickets";
import ReopenTicketModal from "./ReopenTicketModal";

export default function TicketCard({ ticket }: { ticket: any }) {
  const { userRole, canReopenTicket, ticketId } = useTicket(ticket);
  const { open, handleOpen, handleClose } = useModal();

  const path =
    MY_INVOLVED_CONFIG?.[ticket?.myInvolved as keyof typeof MY_INVOLVED_CONFIG]
      ?.link;

  const handleCopy = () => {
    const textToCopy = ticket?.generated_ticket_log_id;
    if (textToCopy) {
      navigator.clipboard.writeText(textToCopy).then(() => {
        message.success(`Copied: ${textToCopy}`);
      });
    }
  };

  return (
    <div className="bg-white p-4 border border-[#D7DFE9] rounded-md flex flex-col justify-between min-h-[278px] gap-3">
      <ReopenTicketModal
        open={open?.open}
        handleClose={handleClose}
        id={ticketId}
      />

      <div className="space-y-2">
        <div className="flex justify-between">
          <div className="text-[#455468] text-[20px]">{ticket?.title}</div>
          <div>
            <Dropdown
              placement="bottomRight"
              menu={{
                items: [
                  {
                    label: (
                      <Link
                        to={`${
                          !!(userRole === "super_admin" || userRole === "Admin")
                            ? "/admin/"
                            : "/user/"
                        }${path}/${ticket?.generated_ticket_log_id}`}
                      >
                        <div className="flex gap-2 items-center">
                          <span>
                            <ViewIcon />
                          </span>
                          <span>View Details</span>
                        </div>
                      </Link>
                    ),
                    key: "1",
                  },
                  ...(canReopenTicket
                    ? [
                        {
                          label: (
                            <div
                              onClick={() => handleOpen({ type: "ADD" })}
                              className="flex gap-2 items-center"
                            >
                              <span>
                                <RefreshIcon />
                              </span>
                              <span>Re-Open</span>
                            </div>
                          ),
                          key: "2",
                        },
                      ]
                    : []),
                ],
              }}
              trigger={["click"]}
            >
              <div className="cursor-pointer">
                <ThreeDotsIcon />
              </div>
            </Dropdown>
          </div>
        </div>
        <div className="flex gap-2 items-center ">
          <span
            className={
              MY_INVOLVED_CONFIG?.[
                ticket?.myInvolved as keyof typeof MY_INVOLVED_CONFIG
              ]?.className
            }
          >
            {formatValue(ticket?.myInvolved)}
          </span>
          <span>{ticket?.generated_ticket_log_id}</span>
          <span className="cursor-pointer" onClick={handleCopy}>
            <CopyIcon />
          </span>
        </div>

        <div className="my-4 flex gap-2 flex-wrap">
          <span
            className={`flex items-center gap-1 ${
              PRIORITY_CONFIG?.[
                ticket?.priority as keyof typeof PRIORITY_CONFIG
              ].className
            }`}
          >
            <FlagIcon />
            {formatValue(
              PRIORITY_CONFIG?.[
                ticket?.priority as keyof typeof PRIORITY_CONFIG
              ].title,
            )}
          </span>
          <div
            className={
              STATUS_CONFIG?.[ticket?.status as keyof typeof STATUS_CONFIG]
            }
          >
            {capitalize(ticket?.status)}
          </div>
        </div>

        <p className=" text-display-body">{ticket?.description}</p>
      </div>

      <Link
        to={`${
          !!(userRole === "super_admin" || userRole === "Admin")
            ? "/admin/"
            : "/user/"
        }${path}/${ticket?.generated_ticket_log_id}`}
      >
        <Button className="button-bordered-light" block>
          View Ticket
        </Button>
      </Link>
    </div>
  );
}
